import axios from '@/api/config';

const xiaoETongLiveInfo = {
  pageList(data) {
    return axios.post(`${process.env.BASE_URL}/xiaoETongLiveInfo/pageList`, data);
  },
  updateXiaoETongLiveInfo(data){
    return axios.put(`${process.env.BASE_URL}/xiaoETongLiveInfo/updateXiaoETongLiveInfo`, data);
  }
};

export default xiaoETongLiveInfo;



// WEBPACK FOOTER //
// ./src/api/xiaoETongLiveInfo.js